import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';

import { Checkbox } from '@components/Form'
import { ExpandableText } from '@components/Form/Checkbox';

export const Agreements = ({ watch, setValue, register, errors, secondRequired }) => {
  const t = useTranslations('main');
  const allCheckRef = useRef<HTMLInputElement>(null);

  const checkboxesWatched = (['marketingAgreement', 'commercialInside', 'commercialOutside'] as const).map((name) => watch(name));

  const labels = {
    marketing: {
      label: t('agreement.marketing.label'),
      contents: t('agreement.marketing.contents'),
    },
    commercialInside: {
      label: t('agreement.commercialInside.label'),
      contents: t('agreement.commercialInside.contents'),
    },
    commercialOutside: {
      label: t('agreement.commercialOutside.label'),
      contents: t('agreement.commercialOutside.contents'),
    },
  }

  const onAcceptAllChange = (e) => {
    setValue('marketingAgreement', !!e.target.checked);
    setValue('commercialInside', !!e.target.checked);
    setValue('commercialOutside', !!e.target.checked);
  }

  useEffect(() => {
    if (allCheckRef.current) {
      allCheckRef.current.checked = checkboxesWatched.reduce((acc, curr) => acc && curr, true);
    }
  }, [...checkboxesWatched]);
  return <>
    <Checkbox
      onChange={onAcceptAllChange}
      ref={allCheckRef}
      wrapperClassName='font-medium mb-2 lg:mb-3'
      className="mr-2"
      name="all"
      label={t('agreement.all')}
    />
    <Checkbox
      required
      {...register('marketingAgreement')}
      error={!!errors?.marketingAgreement}
      wrapperClassName='mb-2 lg:mb-3'
      className="mr-2"
      name="marketingAgreement"
      label={labels.marketing.label}
      tooltip={labels.marketing.contents}
    />
    <Checkbox
      required={secondRequired}
      {...register('commercialInside')}
      error={!!errors?.commercialInside}
      wrapperClassName='mb-2 lg:mb-3'
      className="mr-2"
      name="commercialInside"
      label={labels.commercialInside.label}
      tooltip={labels.commercialInside.contents}
    />
    <Checkbox
      {...register('commercialOutside')}
      error={!!errors?.commercialOutside}
      wrapperClassName='mb-2 lg:mb-3'
      className="mr-2"
      name="commercialOutside"
      label={labels.commercialOutside.label}
      tooltip={labels.commercialOutside.contents}
    />
    <ExpandableText
      error={false}
      text={t('agreement.rodo.label')}
      expandedText={t('agreement.rodo.contents')}
      required={false}
    />
  </>
}